import type { ProductsSubscriptionAdmin, ProductsSubscriptionAdminResponse } from '../types';

const DEFAULT_CURRENCY = 'USD';

function mapInterval(interval: string | null, count: number | null) {
  if (!interval || count === null) return null;
  return { interval, count };
}

export function mapProductsSubscriptionAdmin(data: ProductsSubscriptionAdminResponse): ProductsSubscriptionAdmin {
  return {
    id: data.id,
    status: data.status ?? '',
    store: data.store ?? '',
    sku: data.sku ?? '',
    subscriptionTier: data.subscription_tier,
    amount: data.amount,
    currency: data.currency || DEFAULT_CURRENCY,
    billingInterval: mapInterval(data.subscription_interval, data.subscription_interval_count),
    freeTrial: mapInterval(data.free_trial_interval, data.free_trial_interval_count),
    trialPeriodEndsAt: data.trial_period_ends_at,
    expiresAt: data.expires_at,
    activeStartDate: data.active_start_date,
    canceledAt: data.canceled_at,
    createdAt: data.created_at,
    isManualEntry: data.is_manual_entry,
    isFamilyPlanRedemption: data.is_family_plan_redemption,
    user: { id: data.user.id, name: data.user.name, email: data.user.email },
    product: data.product ? { id: data.product.id, name: data.product.name ?? '' } : null,
  };
}
